import "../assets/scss/index.scss";

import "./modules/Counter";
import "./modules/Hero";
import "./modules/Lightbox";
import "./modules/Map";
import "./modules/Product";
import "./modules/User";
